import { UntypedFormGroup } from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import {
  NextDisplayView,
  PageHeader
} from '../../login-authentication-screen/models/login-credentials.interface';

export interface AddAddressContent {
  formGroup: UntypedFormGroup;
  formAttributes: AddAddressFormAttributes;
  pageContent: AddAddressPageContent;
  isSuccess?: boolean;
  hasError: boolean;
  errorMessage: string;
}

export interface AddAddressPageContent {
  addressLine1Label: string;
  addressLine2Label: string;
  cityLabel: string;
  stateLabel: string;
  countryLabel: string;
  postalCodeLabel: string;
  contentBodyHeader: string;
  buttonLabel: string;
  defaultCountrySelectValue: string;
  defaultStateSelectValue: string;
  nextDisplayView: NextDisplayView;
  viewName: string;
  pageHeader: PageHeader;
  errors: AddAddressErrorMessages;
  countryList: UlItem[];
  stateList: UlItem[];
  addressFields: AddressFields;
}

export interface AddAddressFormAttributes {
  errorCount: number;
  errorAlertBanner: boolean;
  addressLine1ControlTouched: boolean;
  addressLine2ControlTouched: boolean;
  districtControlTouched: boolean;
  stateControlTouched: boolean;
  countryControlTouched: boolean;
  addressLine6ControlTouched: boolean;
  cityControlTouched: boolean;
  postalCodeControlTouched: boolean;
  disableActionButton?: boolean;
  submitAttempt?: boolean;
}

export interface AddAddressErrorMessages {
  addressLine1ErrorMessage: {
    INVALID_ADDR_LINE_1: string;
    ADDR_WITH_NO_LETTERS: string;
  };
  addressLine2ErrorMessage: {
    INVALID_ADDR_LINE_2: string;
  };
  districtErrorMessage: {
    INVALID_DISTRICT: string;
  };
  cityErrorMessage: {
    INVALID_CITY: string;
  };
  stateErrorMessage: {
    SELECT_STATE: string;
    SELECT_PREFECTURE: string;
  };
  postalCodeErrorMessage: {
    INVALID_ZIP_CODE: string;
  };
  alertWarning: string;
}

export type AddressOverlayMessage = { isSuccess: boolean; isError: boolean };

export interface AddressFields {
  addressLine1: AddressLine;
  addressLine2: AddressLine;
  addressLine3: AddressLine;
  addressLine4: AddressLine;
  addressLine5: AddressLine;
  addressLine6: AddressLine;
  addressLine7: AddressLine;
  addressLine9: AddressLine;
  areaCodeRequired?: string;
  faultDO?: { alerts: string[]; status: string };
}

export type AddressFieldsName = keyof AddressFields;

export interface AddressLine {
  visible: boolean;
  label: string;
  required: boolean;
  regex?: string;
  values?: { code: string; value: string }[];
}
